import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { genfunction } from 'helpers'
import CancelIcon from '@material-ui/icons/Cancel'
import { Card, CardContent, CardHeader, IconButton, Table, TableBody, TableCell, TableRow, Hidden } from '@material-ui/core';
import { withRouter } from 'react-router';
import EditIcon from '@material-ui/icons/Edit';
import { useDispatch, useSelector } from 'react-redux';
import { actionShopCartAddMembershipPackage, actionDeleteMembershipTypePerson } from 'actions';
import ErrorHandling from '../../../components/ErrorHandling/ErrorHandling';
import { actionRecalculateGiftCardHold } from 'actions';

const useStyles = makeStyles(theme => ({
    root: {},
    tourheaderbox: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText
    },
    tourheadertext: {
        marginTop: "8px"
    },
    tourbox: {
        marginBottom: "10px"
    },
    labelbold: {
        fontWeight: "bold",
        fontSize: "18px"
    },
    tablecell: {
        padding: "5px"
    },
    AddHoverOnIcons: {
        cursor: "pointer !important"
    }
}));

const MembershipPackagesCard = props => {

    const { className } = props;
    const dispatch = useDispatch();
    const classes = useStyles();
    const [errorMsg, seterrorMsg] = useState("");
    const cashless = useSelector(state => state.reducerShopCart.cashless);


    const changeQuantityHandler = (reference, quantity, memTypeID, mempack) => {
        //Check Min and Max Quantity
        //need to add

        mempack.MembershipProducts = mempack.MembershipProducts.map(memprod => {

            if (memprod.MembershipType === "AddOn" && memprod.MembershipTypeID == memTypeID) {
                memprod.Quantity = quantity;
            }

            return memprod;
        })

        actionShopCartAddMembershipPackage(dispatch, mempack);
    }

    const removemembershipType = (memPackage, memType) => {

        if (memType && memType.MinQuantity < 1) {
            memPackage.MembershipProducts = memPackage.MembershipProducts.map(m => {

                if (m.MembershipTypeID == memType.MembershipTypeID) {
                    if (m.MembershipType === "Membership") {
                        m.Users = [];
                    }
                    else if (m.MembershipType === "AddOn") {
                        m.Quantity = 0;
                    }
                }
                return m;
            });

            actionShopCartAddMembershipPackage(dispatch, memPackage);


        }
        else {
            seterrorMsg('Minimum Quantity for this Membership is ' + memType.MinQuantity + ', You Can not remove it.');
        }
    }

    const removeUserFromMembershipType = (memPackage, memProdType, user) => {

        if (user && user.isPrimaryMember) {
            seterrorMsg(user.firstName + ' ' + user.lastName + ' is primary member, you cannot remove it.');
            return;
        }

        if (memProdType && memProdType.MinQuantity < 1 || (memProdType.MembershipType == "Membership" && memProdType.Users && memProdType.Users.length > memProdType.MinQuantity)) {

            memPackage.MembershipProducts = memPackage.MembershipProducts.map(m => {

                if (m.MembershipTypeID == m.MembershipTypeID && m.MembershipType === "Membership") {

                    m.Users = m.Users.filter(x => x.userNo != user.userNo);
                }

                return m;
            });

            actionShopCartAddMembershipPackage(dispatch, memPackage);
            actionDeleteMembershipTypePerson(dispatch, memPackage.MembershipPackageID, memProdType.MembershipTypeID, user.userNo);

            if (cashless && cashless.length > 0) {
                actionRecalculateGiftCardHold(dispatch);
            }
        }
        else {
            seterrorMsg('Minimum Quantity for this Membership is ' + memProdType.MinQuantity + ', You Can not remove it.');
        }



    }


    const errorcancelhandle = () => {
        seterrorMsg("");
    }

    const replaceEscapeCharacters = (item) => {
        var itemValue = item.split("\\r\\n").join("<br />");
        itemValue = itemValue.split("\\").join("");
        return itemValue;
    }


    const EditMembershipPackage = (membership) => {

        props.history.push({
            pathname: '/memberships/join/' + membership.MembershipPackageID
        })
    }

    return (
        props.membershipPackages ?
            props.membershipPackages.map(memPackage => (
                <Card
                    key={memPackage.MembershipPackageID}
                    className={classes.root + ' ' + classes.tourbox}
                >
                    <CardHeader className={classes.tourheaderbox}
                        title={memPackage.PackageName}
                        titleTypographyProps={{ color: "inherit" }}
                        action={
                            <EditIcon

                                className={classes.AddHoverOnIcons}
                                color={"white"}
                                onClick={() => { EditMembershipPackage(memPackage) }}
                            />
                        }
                    >
                    </CardHeader>
                    <CardContent>
                        <ErrorHandling msg={errorMsg} open={errorMsg != ""} handleclose={errorcancelhandle} />
                        <Table size="small" className={classes.table} aria-label="spanning table">
                            <TableBody>
                                {memPackage.MembershipProducts && memPackage.MembershipProducts.filter(x => x.MembershipType === "Membership" && x.Users !== undefined && x.Users.length > 0).map(memProdType => (

                                    <><TableRow key={memProdType.MembershipTypeID}>
                                        <TableCell className={classes.tablecell} >{replaceEscapeCharacters(memProdType.ProductName)}</TableCell>
                                        <TableCell className={classes.tablecell}>{memProdType.MembershipDuration}</TableCell>
                                        <TableCell className={classes.tablecell} >{genfunction.ccyFormat(memProdType.Price)}</TableCell>
                                        <TableCell className={classes.tablecell} align="right">{genfunction.ccyFormat(memProdType.Price * memProdType.Users.length)}</TableCell>
                                    </TableRow>
                                        {
                                            memProdType.MembershipType === "Membership" && memProdType.Users && memProdType.Users.length > 0 && memProdType.Users.map(user => (
                                                <TableRow key={user.userNo}>
                                                    <Hidden smDown>
                                                        <TableCell className={classes.tablecell}></TableCell>
                                                        <TableCell className={classes.tablecell}></TableCell>
                                                        <TableCell className={classes.tablecell} align="left">
                                                            <IconButton
                                                                edge="end"
                                                                size="small"
                                                                onClick={() => removeUserFromMembershipType(memPackage, memProdType, user)}
                                                            >
                                                                <CancelIcon
                                                                    color={"error"}
                                                                />
                                                            </IconButton>
                                                        </TableCell>
                                                        <TableCell className={classes.tablecell} align="right" colSpan={2}>{user.firstName + ' ' + user.lastName}</TableCell>

                                                    </Hidden>

                                                    <Hidden smUp>
                                                        <TableCell className={classes.tablecell}></TableCell>
                                                        <TableCell className={classes.tablecell} align="left">
                                                            <IconButton
                                                                edge="end"
                                                                size="small"
                                                                onClick={() => removeUserFromMembershipType(memPackage, memProdType, user)}
                                                            >
                                                                <CancelIcon
                                                                    color={"error"}
                                                                />
                                                            </IconButton>
                                                        </TableCell>
                                                        <TableCell className={classes.tablecell} colSpan={2} align="right">{user.firstName + ' ' + user.lastName}</TableCell>

                                                    </Hidden>

                                                </TableRow>

                                            ))
                                        }</>
                                ))}

                                {memPackage.MembershipProducts.filter(x => x.MembershipType === "AddOn" && x.Quantity > 0).map(memProdType => (

                                    <TableRow key={memProdType.MembershipTypeID}>
                                        <TableCell className={classes.tablecell} align="left">
                                            <IconButton
                                                edge="end"
                                                size="small"
                                                onClick={() => removemembershipType(memPackage, memProdType)}
                                            >
                                                <CancelIcon
                                                    color={"error"}
                                                />
                                            </IconButton>
                                        </TableCell>
                                        <TableCell className={classes.tablecell}>{replaceEscapeCharacters(memProdType.ProductName)}</TableCell>

                                        <TableCell className={classes.tablecell} align="right">{genfunction.ccyFormat(memProdType.Price)}</TableCell>

                                        <Hidden smDown>
                                            <TableCell className={classes.tablecell} align="right">{genfunction.ccyFormat(memProdType.Price)}</TableCell>
                                        </Hidden>
                                        <Hidden smUp>
                                            <TableCell className={classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(genfunction.priceRow(1, memProdType.Price))}</TableCell>
                                        </Hidden>
                                    </TableRow>

                                ))}


                                <TableRow>
                                    <TableCell className={classes.tablecell} />
                                    <TableCell className={classes.tablecell} colSpan={2} >Subtotal</TableCell>
                                    <TableCell className={classes.tablecell} colSpan={1} align="right">{genfunction.ccyFormat(memPackage.SubTotal)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tablecell} colSpan={1} />
                                    <TableCell className={classes.tablecell} colSpan={1} >Tax</TableCell>
                                    <TableCell className={classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(memPackage.TotalTax)}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tablecell} colSpan={1} />
                                    <TableCell className={classes.labelbold + " " + classes.tablecell} colSpan={1}>Total</TableCell>
                                    <TableCell className={classes.labelbold + " " + classes.tablecell} colSpan={2} align="right">{genfunction.ccyFormat(memPackage.TotalAmount)}</TableCell>
                                </TableRow>

                            </TableBody>
                        </Table>
                    </CardContent>
                </Card >

            )) : null
    );
};


export default withRouter(MembershipPackagesCard);
